// extracted by mini-css-extract-plugin
export var cell = "_68-4";
export var headerCell = "_68-2";
export var rowHeader = "_68-3";
export var table = "_68-1";
export var tableContainer = "_68-0";